module.exports = __webpack_public_path__ + "img/dss.563c4fb4.svg";